// extracted by mini-css-extract-plugin
export default {"root":"zNVRO","traded":"_27UMo","icon":"_397Xf","warning":"_3TZ1U"};